import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {RouteService} from '../../../services/route-service';
import {LocationDto, Points} from '../../../model/continent';
import {FormsModule} from '@angular/forms';
import {NgForOf, NgIf} from '@angular/common';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {deepEqual} from '../../../functions/deepEqual';
import {Notification, NotificationType} from '../../../model/notification';
import {NotificationService} from '../../../services/notification-service';
import {findFirstCity, isRussianText} from '../../../functions/findFirstCityUrl';

@Component({
  selector: 'app-set-route',
  imports: [
    FormsModule,
    NgForOf,
    NgIf
  ],
  templateUrl: './set-route.component.html',
  styleUrl: './set-route.component.scss'
})
export class SetRouteComponent {
  constructor(private router: Router,
              protected routeService: RouteService,
              private sanitizer: DomSanitizer,
              private notificationService: NotificationService) {
  }

  id: number = 0;
  initRoute: LocationDto = new LocationDto();
  route: LocationDto = new LocationDto();
  info: SafeHtml = '';

  countInOnePack: number = 2;

  forProcessing: string = '';

  processed: string = '';

  comment: string = '';


  getUnprocessedRoutes() {
    this.routeService.getRouteList({query: '', pageSize: 1000, pageNumber: 0, sort: ''}).subscribe(res => {
      const routes = res.content ?? [];
      const ids = routes.filter(route => {
        const isCity = findFirstCity(route.points);
        const newPoints = route.points.filter(point => {
          const eventsCount = point.events.length;
          const titleEnCount = point.events.filter(v => v.titleEn && v.titleEn.length > 0).length;
          const titleRuCount = point.events.filter(v => v.titleRu && v.titleRu.length > 0).length;
          const descriptionEnCount = point.events.filter(v => v.descriptionEn && v.descriptionEn.length > 0).length;
          const descriptionRuCount = point.events.filter(v => v.descriptionRu && v.descriptionRu.length > 0).length;
          return !(titleEnCount == eventsCount) || !(titleRuCount == eventsCount) || !(descriptionEnCount == eventsCount)
            || !(descriptionRuCount == eventsCount) || (!point.titleEn) || (point.titleRu && !isRussianText(point.titleRu)) || (!isCity);
        });
        return newPoints.length > 0;
      }).map(v => {return v.id});
      this.comment = ids.length == 0 ? 'All routes have been processed.' : 'Routes have no processed events: ' +  ids.join(', ');
    })
  }

  getRoute() {
    this.routeService.getRoute(this.id).subscribe(route => {
      this.route = JSON.parse(JSON.stringify(new LocationDto(route)));
      this.initRoute = JSON.parse(JSON.stringify(new LocationDto(route)));
      this.getProcessing();
    });
  }

  saveRoute() {
    this.routeService.saveRoute(this.route).subscribe(() => {
      this.forProcessing = '';
      this.processed = '';
      this.getRoute();
      this.notificationService.implementNotification(new Notification({
        title: `Success`,
        text: `The route id ${this.id} has been saved`,
        style: NotificationType.success
      }), 5000);
    });
  }


  getProcessing() {
    let shArr: Points[] = [];
    this.route.points.forEach(point => {
     const newPoint: any = {
       id: point.id,
       titleEn: point.titleEn,
       titleRu: point.titleRu,
       events: point.events
         .filter(event => event.id && event.titleEn && (!event.titleRu || !event.descriptionEn || !event.descriptionRu))
         .map(v => {
         return {
           id: v.id,
           titleEn: v.titleEn
         }
       }) ?? []
     };
      shArr.push(newPoint);
    });
    shArr = shArr.filter(v => {
      return !v.titleRu || (v.titleRu && !isRussianText(v.titleRu)) ||  (v.events.filter(f => {
        return (!f.titleRu || !f.descriptionEn || !f.descriptionRu)
      })).length > 0
    })
    this.forProcessing = JSON.stringify(shArr.slice(0, this.countInOnePack), null, 2);
  }

  setProcessed() {
    if (this.processed.length > 0) {
      const processed: Points[] = JSON.parse(this.processed);
      this.route.points.forEach(point => {
        point.titleRu = processed.find(p => p.id == point.id)?.titleRu ?? point.titleRu;
        point.events.forEach(event => {
          if (event.id && event.titleEn) {
            const newItem = processed.find(p => p.id === point.id)?.events.find(e => e.id === event.id);
            if (newItem) {
              event.titleRu = newItem.titleRu;
              event.descriptionEn = newItem.descriptionEn;
              event.descriptionRu = newItem.descriptionRu;
            }
          }
        })
      });
    }
  }

  copyText(text: string) {
    navigator.clipboard.writeText(text).then(
      () => {
      },
      (err) => {
        // console.error('Ошибка копирования: ', err);
      }
    );
  }


  async getClipboardContent(): Promise<string> {
    try {
      const text = await navigator.clipboard.readText();
      return text;
    } catch (err) {
      console.error('Ошибка при чтении буфера обмена:', err);
      return '';
    }
  }
  async pasteText() {
    this.processed = await this.getClipboardContent();
  }

  getInfo(point: Points) {
    const titleEn = point.titleEn?.split(":")[0];
    const titleRu = point.titleRu?.split(":")[0];
    const eventsCount = point.events.length;
    const titleEnCount = point.events.filter(v => v.titleEn && v.titleEn.length > 0).length;
    const titleRuCount = point.events.filter(v => v.titleRu && v.titleRu.length > 0).length;
    const descriptionEnCount = point.events.filter(v => v.descriptionEn && v.descriptionEn.length > 0).length;
    const descriptionRuCount = point.events.filter(v => v.descriptionRu && v.descriptionRu.length > 0).length;
    const html = `<b>${titleEn}</b>;
            <span style="${titleRu ? 'color: green;' : 'color: red;' }">t-RU</span>;
            <span style="${titleEnCount == eventsCount ? 'color: green;' : 'color: red;' }">t-En(${titleEnCount} / ${eventsCount})</span>;
            <span style="${titleRuCount == eventsCount ? 'color: green;' : 'color: red;' }">t-Ru(${titleRuCount} / ${eventsCount})</span>;
            <span style="${descriptionEnCount == eventsCount ? 'color: green;' : 'color: red;' }">d-En(${descriptionEnCount} / ${eventsCount})</span>;
            <span style="${descriptionRuCount == eventsCount ? 'color: green;' : 'color: red;' }">d-Ru(${descriptionRuCount} / ${eventsCount})</span>;`
   return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  protected readonly deepEqual = deepEqual;
}
